import React, { useEffect, useMemo } from 'react';
import { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import useDefaultTwoLevelFilter from '../../hooks/useDefaultTwoLevelFilter';
import { heroLocale, heroRadioOptions } from '../../constants/hero';
import './index.scss';
import { useIntl } from 'umi';
import { addFilterBuriedPoint } from '../../utils/point';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { heroPlaceholder } from '../../constants/placeholder';

export default function HeroSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const [heroOptions, allValue]: any = useMemo(() => {
    const filterMap: any = {};
    const { hero, hero_type } = filterOptions || {};
    let allValue: Array<string> = [];
    if (hero?.length > 0) {
      hero_type.forEach(
        ({
          name_en: type_en,
          name_zh: type_zh,
        }: {
          name_en: string;
          name_zh: string;
        }) => {
          if (!filterMap[type_en]) {
            filterMap[type_en] = {
              value: type_en,
              text: type_en,
              textCN: type_zh,
              children: [],
            };
          }
          hero.forEach(
            ({
              icon,
              name_en,
              name_zh,
              types,
            }: {
              icon: string;
              name_en: string;
              name_zh: string;
              types: string;
            }) => {
              if (types.includes(type_en)) {
                filterMap[type_en].children.push({
                  value: name_en,
                  text: name_en,
                  textCN: name_zh,
                  icon,
                });
              }
            },
          );
        },
      );
      allValue = hero.map((item: any) => item.name_en);
    }

    const resultOptions = Object.values(filterMap);

    return [resultOptions, allValue];
  }, [filterOptions]);

  const {
    setSelectValue,
    selectValue,
    onChange: onTopicChange,
    diffClassName,
  } = useDefaultTwoLevelFilter({
    originalOptions: heroOptions,
    defaultValue,
    filterValue,
    onlySecondLevelValue: true,
    normalizeToLowercase: false,
    dealwithDefaultValue: (value: any) => {
      const keyword_en = value?.keyword_en || [];
      return { value: keyword_en, type: 'market' };
    },
  });

  const heroChange = (tags: any) => {
    setSelectValue(tags);
  };

  const buttonElement = useMemo(() => {
    const { value } = onTopicChange(selectValue, true);
    const isAll = allValue.length === value.length || value.length === 0;

    return (
      <div>
        <span>{heroPlaceholder[lang]}</span>
        <span>{isAll ? formatMessage({ id: 'All' }) : value.length}</span>
      </div>
    );
  }, [formatMessage, selectValue]);

  useEffect(() => {
    const { value } = onTopicChange(selectValue);

    onChange?.(
      'hero',
      commonBackInfo(
        { keyword_en: value },
        {
          [defaultKey]: value.length === 0 ? 'All' : value?.length,
        },
      ),
    );
  }, [selectValue, formatMessage]);

  return (
    <div
      className={`hero-select-wrapper two-select-info-wrapper ${diffClassName}`}
    >
      <NewRegionSelect
        value={selectValue}
        options={heroOptions}
        locale={lang}
        language={heroLocale}
        closeOnScroll={true}
        radioOptionsTips={{ global: ' ', global_wo_china: ' ' }}
        radioOptions={heroRadioOptions}
        boxClassName="dbo-hero-dropdown-wrapper"
        button={buttonElement}
        onCloseReginSelect={(result: any) => {
          heroChange(result);

          try {
            const { value } = onTopicChange(result);
            addFilterBuriedPoint(
              FilterButtonPoint.hero,
              value.length === 0 ? 'All' : value,
            );
          } catch (error) {}
        }}
      ></NewRegionSelect>
    </div>
  );
}
